import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Container,
  Flex,
  Grid,
  Heading,
  Image,
  Text,
  VStack,
} from '@chakra-ui/react';
import { Button } from '../components/Button';
import dominus_logo_transparent_white from '../assets/dominus_logo_transparent_white.png';
import VisitorFooter from '../components/VisitorFooter';
import { useUserStore } from '../store/userStore';

const HomeLanding = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useUserStore();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, navigate]);

  return (
    <Box 
      minHeight="100vh"
      w="100%"
      position="absolute"
      top="0"
      left="0"
      bgGradient="linear(to-b, black, #002e0b)"
      color="white"
      fontFamily="'Exo 2', sans-serif"
      display="flex"
      flexDirection="column"
    >
      {/* Navigation Bar */}
      <Box
        id="box1"
        as="nav"
        position="fixed"
        top={0}
        w="100%"
        bg="transparent"
        backdropFilter="blur(8px)"
        zIndex={50}
      >
        <Flex 
          justifyContent="space-between" 
          maxW="8xl" 
          mx="auto"
          px={4}
          py={4}
          alignItems="center"
        >
          <Box flexShrink={0}>
            <Image src={dominus_logo_transparent_white} alt="Dominus" h={12} />
          </Box>
          <Flex alignItems="center">
            <Button
              onClick={() => navigate('/signin')}
              px={8}
              py={2}
              visual="dominus"
            >
              Sign In
            </Button>
            <Button
              onClick={() => navigate('/signup')}
              px={8}
              py={2}
              visual="dominus"
              ml={4}
            >
              Register
            </Button>
          </Flex>
        </Flex>
      </Box>

      {/* Hero Section */}
      <Box pt={32} pb={16} flex="1 1 auto">
        <Container maxW="7xl">
          <VStack
            spacing={8}
            align="center"
            justify="center"
            minH="60vh"
          >
            <Heading
              as="h1"
              size="2xl"
              textAlign="center"
              fontWeight="extrabold"
              color="white"
            >
              <Text fontFamily="Audiowide">Master your sport.</Text>
              <Text fontFamily="Audiowide">Dominate your league.</Text>
            </Heading>
            <Text
              fontSize={{ base: 'lg', md: 'xl' }}
              color="white"
              maxW="3xl"
              textAlign="center"
              opacity={0.9}
            >
              Take control of your game with advanced analytics, real-time insights, and strategic tools designed for champions.
            </Text>
            <Button
              onClick={() => navigate('/signup')}
              variant="outline"
              size="lg"
              px={6}
              py={3}
              visual="dominus"
            >
              Get Started
            </Button>
          </VStack>
        </Container>
      </Box>

      {/* Feature Section */}
      <Box py={12} bg="black">
        <Container maxW="7xl">
          <Grid
            templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }}
            gap={8}
          >
            <Box
              p={6}
              rounded="lg"
              bg="#190021"
              textAlign="center"
            >
              <Heading as="h3" size="lg" color="white" mb={2}>
                Advanced Analytics
              </Heading>
              <Text color="white" opacity={0.9}>
                Deep insights into your performance and strategy
              </Text>
            </Box>
            <Box
              p={6}
              rounded="lg"
              bg="#190021"
              textAlign="center"
            >
              <Heading as="h3" size="lg" color="white" mb={2}>
                Real-time Updates
              </Heading>
              <Text color="white" opacity={0.9}>
                Stay ahead with instant game data and analysis
              </Text>
            </Box>
            <Box
              p={6}
              rounded="lg"
              bg="#190021"
              textAlign="center"
            >
              <Heading as="h3" size="lg" color="white" mb={2}>
                Strategic Tools
              </Heading>
              <Text color="white" opacity={0.9}>
                Make data-driven decisions to outplay your competition
              </Text>
            </Box>
          </Grid>
        </Container>
      </Box>

      <VisitorFooter />
    </Box>
  );
};

export default HomeLanding;
